import React, { useRef } from 'react';
import { Modal } from 'bootstrap';
import { useMutation } from '@apollo/client';
import { REQUEST_CI } from './mutations';
import { useToastContext } from './context';
import { getCaseIdFromUrl } from './hooks';
import { TOASTS } from './shared/dictionary';

const RequestCiModal = () => {
    let id = getCaseIdFromUrl();
    const ref = useRef();
    const { showToast } = useToastContext();

    const [requestCi, { loading }] = useMutation(REQUEST_CI, {
        onCompleted: () => handleComplete(),
        onError: (e) => {
            showToast({ ...TOASTS.error, message: e.message });
        },
        refetchQueries: ['Conversations']
    });

    const handleComplete = () => {
        var modal = Modal.getOrCreateInstance(ref.current);
        modal?.hide();
        showToast({ ...TOASTS.success, message: 'Submitted request for client inquiry.' });
    }

    const handleSubmit = () => {
        requestCi({ variables: { id } });
    }

    return (
        <div
            className="modal fade"
            id="webformRequestCiModal"
            tabIndex="-1"
            aria-hidden="true"
            ref={ref}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Request for client inquiry</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to request for client inquiry?</p>
                    </div>
                    <div className="modal-footer gap-3">
                        <button
                            type="button"
                            className="btn btn-link-default btn-sm"
                            data-bs-dismiss="modal"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-dark btn-sm"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequestCiModal;